<template>
  <div class="container" style="overflow: hidden">
    <MdHeaderBar2
      :hide_close="true"
      :hide_back="false"
      :title="{
        isSingle: true,
        primary : step1_info.site_idx > 0 ? $t('register.modify_new_open_site') : $t('register.reg_new_open_site')
      }" />
    <div class="scroll-body">
      <div class="align-vertical" style="padding:0 13px; margin-bottom: 20px">
        <div class="align-vertical" style="margin-top: 28px">
          <div class="caption">{{$t('register.east_floor')}}</div>
          <div class="align-horizontal v_center" style="margin-top: 12px"
               v-for="(item, idx) in dong_list"
               :key="`dong-floor-${idx}`">
            <b-form-input class="input input_wrapper" style="margin-right: 5px; text-align: center;" v-model="item.dong" />
            <span class="input_caption">{{$t('register.dong')}}</span>
            <MFSelect
              class="input_wrapper input mr-1"
              style="border-color: #eeeeef; margin: auto 5px;"
              :vmodel="item.floor"
              :drop="true"
              @change="(value) => {
                item.floor = value;
              }"
              :options="getNumList($c.MAX_FLOOR_CNT)"
            />
            <!-- <b-form-select
              v-model="item.floor"
              style="border-color: #eeeeef; margin: auto 5px;"
              class="input_wrapper input mr-1">
              <option v-for="(num, idx) in getNumList($c.MAX_FLOOR_CNT)" :key="idx" :value="idx + 1">
                {{num}}
              </option>
            </b-form-select> -->
            <span class="input_caption">{{$t('register.floor')}}</span>
            <MFSelect
              class="input_wrapper input mr-1"
              style="border-color: #eeeeef; margin: auto 5px;"
              :vmodel="item.ho"
              :drop="true"
              @change="(value) => {
                item.ho = value;
                let hoCount = 0;
                for (let i = 0; i < self.dong_list.length; i++) {
                  hoCount += self.dong_list[i].ho;
                }
                let remain = self.step1_info.house_count - hoCount;
                self.remain_ho_count = remain;
              }"
              :options="getNumList($c.MAX_HOUSE_PER_FLOOR_CNT)"
            />
            <!-- <b-form-select
              v-model="item.ho"
              style="border-color: #eeeeef; margin: auto 5px;"
              class="input_wrapper input mr-1"
              @change="() => {
              let hoCount = 0;
              for (let i = 0; i < self.dong_list.length; i++) {
                hoCount += self.dong_list[i].ho;
              }
              let remain = self.step1_info.house_count - hoCount;
              self.remain_ho_count = remain;
            }">
              <option v-for="(num, idx) in getNumList($c.MAX_HOUSE_PER_FLOOR_CNT)" :key="idx" :value="idx + 1">
                {{num}}
              </option>
            </b-form-select> -->
            <span class="input_caption">{{$t('register.household')}}</span>
            <div style="flex: 1" />
            <b-button class="btn btn_text ml-1" @click="onAddDong(idx)">{{getInputText(idx)}}</b-button>
          </div>
<!--          {/*renderDongHo*/}-->
          <div class="align-vertical"
               style="margin-top: 20px"
               :key="`dong-ho-${dongIndex}`"
               v-for="(dongInfo, dongIndex) in dong_list" v-if="dongInfo.editable">
            <div class="align-horizontal" style="margin-bottom:10px;">
              <span class="caption">{{dongInfo.dong}}{{$t('register.ho_input')}}</span>
              <span class="caption_red">{{$t('register.ho_input_desc')}}</span>
              <div class="flex_1" />
              <b-button class="small_btn_red1 small_btn_text mr-2" @click="()=>{
                self.ho_list = self.ho_list.filter(it => {
                  if (it.dong_index === dongIndex)
                   {
                     it.sale_price = '';
                     it.collateral_price = '';
                     it.charter_price = '';
                     it.investment_price = '';
                     it.monthly_rent = '';
                     it.monthly_rent_deposit = '';
                   }
                  return it
                })}">{{$t('common.remove_price')}}</b-button>
              <b-button class="small_btn_grey small_btn_text" @click="()=>{
                self.ho_list = self.ho_list.filter(it => {
                  return it.dong_index !== dongIndex;
                })}">{{$t('common.delete1')}}</b-button>

            </div>
            <div class="align-horizontal v_center margin-bottom-5"
                 v-for="(floorIndex, idx) in floorList(dongInfo)" :key="`floor-${idx}`">
              <div class="align-vertical v_center">
                <span class="small_btn_text" style="color: black; margin-left: 5px">{{floorIndex + 1}}{{$t('register.floor')}}</span>
                <b-button class="small_btn_blue small_btn_text" style="margin-left: 6px;" @click="onAddHo(dongIndex, floorIndex)">
                  {{$t('register.add')}}
                </b-button>
              </div>
              <div class="align-horizontal" style="flex: 1; margin-left: 20px; flex-wrap: wrap;">
                <b-button class="ho_container align-vertical"
                          v-for="(hoInfo, i) in ho_list.filter(_hoInfo => {return _hoInfo.dong_index == dongIndex && _hoInfo.floor == (floorIndex + 1);})"
                          :key="`ho-btn-${i}`"
                          @click="onUpdateHo(dongIndex, floorIndex, i)"
                          style="flex:1; margin-left: 5px; position: relative; height: 140px; justify-content: flex-start">
                  <div class="trans_wrapper align-horizontal">
                    <div class="trans_tag"
                         :class="{'trans_trading_active': hoInfo.trans_type.split(',').includes('0')}">
                      {{ho_list.filter(_hoInfo => {return _hoInfo.dong_index == dongIndex && _hoInfo.floor == (floorIndex + 1);}).length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[0] : ''}}
                    </div>
                    <div class="trans_tag"
                         :class="{'trans_charter_active': hoInfo.trans_type.split(',').includes('1')}">
                      {{ho_list.filter(_hoInfo => {return _hoInfo.dong_index == dongIndex && _hoInfo.floor == (floorIndex + 1);}).length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[1] : ''}}
                    </div>
                    <div class="trans_tag"
                         :class="{'trans_month_active': hoInfo.trans_type.split(',').includes('3')}">
                      {{ho_list.filter(_hoInfo => {return _hoInfo.dong_index == dongIndex && _hoInfo.floor == (floorIndex + 1);}).length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[3] : ''}}
                    </div>
                    <div class="trans_tag"
                         :class="{'trans_invest_active': hoInfo.trans_type.split(',').includes('2')}">
                      {{ho_list.filter(_hoInfo => {return _hoInfo.dong_index == dongIndex && _hoInfo.floor == (floorIndex + 1);}).length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[2] : ''}}
                    </div>
                  </div>
                  <div class="align-horizontal v_center h_center width_100 flex_1">
                    <b-img
                      :src="require('../../../../assets/image/ic_photo.png')"
                      v-if="
                        hoInfo.image_urls.split(',').filter((it) => {
                          return it != '';
                        }).length > 0
                      "
                      style="
                        margin-right: 5px;
                        width: 20px;
                        height: 17px;
                        margin-bottom: 2px;
                      "
                    />
                    <span
                      class="grid_text"
                      :style="{
                        color: hoInfo.f_complete == 'Y' ? 'white' : 'black',
                      }"
                    >{{ hoInfo.ho }}</span
                    >
                  </div>
                  <div class="room_toilet_wrapper align-horizontal">
                    {{
                      ho_list.filter(_hoInfo => {return _hoInfo.dong_index == dongIndex && _hoInfo.floor == (floorIndex + 1);}).length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ?
                        ut.format($t('site_detail.room_toilet_num'), renderRoomNum(hoInfo.room), hoInfo.toilet) :
                        ut.format($t('site_detail.room_toilet_num_short'), renderRoomNum(hoInfo.room), hoInfo.toilet)
                    }}
                  </div>
                  <div class="dup_teras_wrapper align-horizontal">
                    <div class="trans_tag" :class="{'dup_teras_active': hoInfo.duplex == 'Y'}">
                      {{ho_list.filter(_hoInfo => {return _hoInfo.dong_index == dongIndex && _hoInfo.floor == (floorIndex + 1);}).length < $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY - 1  ?
                      $t('room_info_popup.duplex') : $t('room_info_popup.duplex_short')}}
                    </div>
                    <div class="trans_tag" :class="{'dup_teras_active': hoInfo.teras == 'Y'}">
                      {{ho_list.filter(_hoInfo => {return _hoInfo.dong_index == dongIndex && _hoInfo.floor == (floorIndex + 1);}).length < $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY - 1  ?
                      $t('site_detail.teras') : $t('site_detail.teras_short')}}
                    </div>
                  </div>
                </b-button>
              </div>
            </div>
            <div>
              <div class="align-horizontal h_center margin-top-20" style="width: 100%;float: right;">
                <MFSelect
                  class="input_wrapper input"
                  style="width: 70px; height: 40px; border-color: #eeeeef; margin: auto 5px;"
                  :vmodel="floor_copy_list[dongIndex].from"
                  :drop="true"
                  @change="(value) => {
                    floor_copy_list[dongIndex].from = value;
                  }"
                  :options="floorList2(dongInfo)"
                />
                <!-- <b-form-select class="input_wrapper input"
                              v-model="floor_copy_list[dongIndex].from"
                              style="width: 70px; height: 40px; border-color: #eeeeef; margin: auto 5px;">
                  <option v-for="(val, idx) in floorList(dongInfo)" :key="idx" :value="idx + 1">{{val + 1}}</option>
                </b-form-select> -->
                <span class="input_caption" style="margin-right: 7px">{{$t('register.copy_info')}}</span>
                <div style="margin: auto 5px">
                  <MFSelect
                    class="input_wrapper input"
                    style="width: 70px; height: 40px; border-color: #eeeeef"
                    :vmodel="floor_copy_list[dongIndex].to"
                    :drop="true"
                    @change="(value) => {
                      floor_copy_list[dongIndex].to = value;
                    }"
                    :options="floorList2(dongInfo)"
                  />
                  <!-- <b-form-select class="input_wrapper input"
                                v-model="floor_copy_list[dongIndex].to"
                                style="width: 70px; height: 40px; border-color: #eeeeef">
                    <option v-for="(val, idx) in floorList(dongInfo)" :key="idx" :value="idx + 1">{{val + 1}}</option>
                  </b-form-select> -->
                </div>
                <span class="input_caption">{{$t('register.to_this_floor1')}}</span>
                <MFSelect
                  class="input_wrapper input"
                  style="width: 120px; height: 40px; border-color: #eeeeef"
                  :vmodel="floor_copy_list[dongIndex].mode == 'A' ? $t('register.all_info') : $t('register.only_photo')"
                  :drop="true"
                  @change="(value) => {
                    floor_copy_list[dongIndex].mode = value == $t('register.all_info') ? 'A' : 'P';
                  }"
                  :options="[$t('register.all_info'), $t('register.only_photo')]"
                />
                <!-- <b-form-select class="input_wrapper input"
                              v-model="floor_copy_list[dongIndex].mode"
                              style="width: 120px; height: 40px; border-color: #eeeeef">
                  <option v-for="(key, val, idx) in $c.COPY_OPTIONS" :key="idx" :value="key">{{val}}</option>
                </b-form-select> -->
                <b-button class="small_btn_blue1 small_btn_text ml-2" style="margin-right: 8px" @click="onCopyFloor(dongIndex)">{{$t('common.copy')}}</b-button>
              </div>
            </div>
            <div class="align-vertical" style="margin-top: 33px" :key="`dong-table-${dong_idx}`"
                 v-for="({dongInfo, floorList, ho_list, saleShow, investShow, charterShow, monthlyShow}, dong_idx) in forDongTable" v-if="dongIndex == dong_idx">
              <div class="align-vertical" v-if="ho_list.length > 0">
                <div style="margin-bottom: 12px">
                  <span class="caption">{{dongInfo.dong}}{{$t('register.dong')}}</span>
                </div>
                <!--              {/*renderDongTableHeader*/}-->
                <div class="align-horizontal header_container">
                  <div class="item_view" style="width: 50px; border-left-width: 0">
                    <span class="item_label_bold">{{ $t("register.ho") }}</span>
                  </div>
                  <div class="item_view" style="flex: 0.5">
                    <span class="item_label_bold">{{ $t("register.room") }}</span>
                  </div>
                  <div class="item_view" style="flex: 0.5">
                  <span class="item_label_bold">{{
                      $t("site_detail.toilet1")
                    }}</span>
                  </div>
                  <div class="item_view trans_trading_active" v-if="saleShow" style="flex: 1">
                  <span class="item_label_bold" style="color: white">{{
                      $t("register.parcel_out")
                    }}</span>
                  </div>
                  <div class="item_view trans_trading_active"
                       v-if="saleShow" style="flex: 1">
                  <span class="item_label_bold" style="color: white">{{
                      $t("site_detail.collateral_short")
                    }}</span>
                  </div>
                  <div class="item_view trans_charter_active" v-if="charterShow" style="flex: 1">
                  <span class="item_label_bold" style="color: white">{{
                      $t("interest.charter")
                    }}</span>
                  </div>
                  <div class="item_view trans_month_active" v-if="monthlyShow" style="flex: 1.8">
                  <span class="item_label_bold" style="color: white">{{
                      $t("interest.monthly")
                    }}</span>
                  </div>
                  <div class="item_view trans_invest_active" v-if="investShow" style="flex: 1">
                  <span class="item_label_bold" style="color: white">{{
                      $t("interest.invest")
                    }}</span>
                  </div>
                  <div class="item_view" style="flex: 1">
                  <span class="item_label_bold">{{
                      $t("site_detail.private")
                    }}</span>
                  </div>
                  <div class="item_view" style="flex: 1">
                  <span class="item_label_bold">{{
                      $t("site_detail.dup_teras")
                    }}</span>
                  </div>
                </div>
                <div v-for="(floorIndex, index) in floorList" class="align-vertical" :key="index.toString()">
                  <!--                {/*renderDongTableItem*/}-->
                  <div class="align-horizontal flex_1"
                       v-for="(item, idx) in ho_list.filter(ho => {return ho.floor == floorIndex + 1}).sort((a, b) => {return a.ho - b.ho})"
                       :key="`dong-item-${idx}`">
                    <div class="align-horizontal row_container" v-if="item.memo == ''">
                      <div class="th blind" style="width: 50px;border-left-width: 0 ">
                        <span class="cell_text">{{renderText(item.ho)}}</span>
                      </div>
                      <div class="th blind" style="flex: 0.5; ">
                        <span class="cell_text">{{renderText(renderRoomNum(item.room))}}</span>
                      </div>
                      <div class="th blind" style="flex: 0.5; ">
                        <span class="cell_text">{{renderText(item.toilet)}}</span>
                      </div>
                      <div v-if="saleShow" class="th blind"
                           style="flex: 1; ">
                        <span class="cell_text">{{item.trans_type.split(',').includes('0') ? (item.site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(item.sale_price == null ? '' : item.sale_price))) : '-'}}</span>
                      </div>
                      <div v-if="saleShow" class="th blind"
                           style="flex: 1; ">
                      <span class="cell_text">
                        {{item.trans_type.split(',').includes('0') ? (item.site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                        renderText(u.currency(item.collateral_price == null ? '' : item.collateral_price))) : '-'}}</span>
                      </div>
                      <div v-if="charterShow" class="th blind"
                           style="flex: 1; ">
                        <span class="cell_text">{{item.trans_type.split(',').includes('1') ? (item.site_inquire_charter == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(item.charter_price))) : '-'}}</span>
                      </div>

                      <div v-if="monthlyShow" class="th blind"
                           style="flex: 1.8; ">
                      <span class="cell_text">
                        {{
                          item.trans_type.split(',').includes('3') ? (item.site_inquire_month == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(
                              [
                                u.currency(
                                  item.monthly_rent_deposit
                                    ? item.monthly_rent_deposit
                                    : ""
                                ),
                                u.currency(
                                  item.monthly_rent ? item.monthly_rent : ""
                                ),
                              ]
                                .filter((it) => {
                                  return it != "" && it != "0";
                                })
                                .join("/")
                            )) : '-'
                        }}
                      </span>
                      </div>
                      <div v-if="investShow" class="th blind"
                           style="flex: 1; ">
                        <span class="cell_text">{{item.trans_type.split(',').includes('2') ? (item.site_inquire_investment == 'Y' ? $t('site_detail.site_inquire_short'):
                        renderText(u.currency(item.investment_price))) : '-'}}</span>
                      </div>
                      <div class="th blind" style="flex: 1; ">
                        <span class="cell_text">{{renderText(item.exclusive_size)}}</span>
                      </div>
                      <!--                    <div class="item_view" style="flex: 1; ">-->
                      <!--                      <span class="item_label">{{renderText(item.real_size)}}</span>-->
                      <!--                    </div>-->
                      <div class="item_view" style="flex: 1; ">
                        <span class="cell_text">{{renderDupTerasText(item.duplex, item.teras)}}</span>
                      </div>
                    </div>
                    <div class="align-horizontal row_container" style="width: 100%" v-else>
                      <div class="item_view1" style="width: 50px; ">
                        <span class="cell_text">{{renderText(item.ho)}}</span>
                      </div>
                      <div class="th_double flex_1" style="width: calc(100% - 50px)">
                        <div class="align-horizontal th3 flex_1" style="border-top-width: 0">
                          <div class="th blind" style="flex: 0.5; ">
                            <span class="cell_text">{{renderText(renderRoomNum(item.room))}}</span>
                          </div>
                          <div class="th blind" style="flex: 0.5; ">
                            <span class="cell_text">{{renderText(item.toilet)}}</span>
                          </div>
                          <div v-if="saleShow" class="th blind"
                               style="flex: 1; ">
                            <span class="cell_text">{{item.trans_type.split(',').includes('0') ? (item.site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                              renderText(u.currency(item.sale_price))) : '-'}}</span>
                          </div>
                          <div v-if="saleShow" class="th blind"
                               style="flex: 1; ">
                            <span class="cell_text">{{item.trans_type.split(',').includes('0') ? (item.site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                              renderText(u.currency(item.collateral_price == null ? '' : item.collateral_price))): '-'}}</span>
                          </div>
                          <div v-if="charterShow" class="th blind"
                               style="flex: 1; ">
                            <span class="cell_text">{{item.trans_type.split(',').includes('1') ? (item.site_inquire_charter == 'Y' ? $t('site_detail.site_inquire_short'):
                              renderText(u.currency(item.charter_price))) : '-'}}</span>
                          </div>
                          <div v-if="monthlyShow" class="th blind"
                               style="flex: 1.8; ">
                            <span class="cell_text">{{item.trans_type.split(',').includes('3') ? (item.site_inquire_month == 'Y' ? $t('site_detail.site_inquire_short'):
                              renderText(
                              [
                                u.currency(
                                  item.monthly_rent_deposit
                                    ? item.monthly_rent_deposit
                                    : ""
                                ),
                                u.currency(
                                  item.monthly_rent ? item.monthly_rent : ""
                                ),
                              ]
                                .filter((it) => {
                                  return it != "" && it != "0";
                                })
                                .join("/")
                            )): '-'}}</span>
                          </div>
                          <div v-if="investShow" class="th blind"
                               style="flex: 1; ">
                            <span class="cell_text">{{item.trans_type.split(',').includes('2') ? (item.site_inquire_investment == 'Y' ? $t('site_detail.site_inquire_short'):
                              renderText(u.currency(item.investment_price))) : '-'}}</span>
                          </div>
                          <div class="th blind" style="flex: 1; ">
                            <span class="cell_text">{{renderText(item.exclusive_size)}}</span>
                          </div>
                          <!--                        <div class="item_view" style="flex: 1; ">-->
                          <!--                          <span class="item_label">{{renderText(item.real_size)}}</span>-->
                          <!--                        </div>-->
                          <div class="th blind" style="flex: 1; ">
                            <span class="cell_text">{{renderDupTerasText(item.duplex, item.teras)}}</span>
                          </div>
                        </div>
                        <div class="th2 flex_1 line-one item_label" style="width: auto; border-top: solid 1px #d0d0d0;border-left: solid 1px #d0d0d0; padding-left: 10px !important; text-align: left; line-height: 29px;">
                          {{replaceEnter(item.memo)}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
<!--          {/*renderDongTables*/}-->

        </div>
      </div>
      <div class="align-horizontal mt-2" style="align-self: stretch;width: 480px;margin: auto; position:fixed; bottom: 0">
        <b-button class="cancel_btn reg_btn_text no_border_radius" style="flex: 1" variant="secondary" @click="onCancel">
          {{$t('common.cancel')}}
        </b-button>
        <b-button class="next_btn reg_btn_text no_border_radius" style="flex: 1" variant="primary" @click="onSaveSite">
          {{$t('register.save')}}
        </b-button>
      </div>
    </div>
    <HouseholdEditPopup v-if="showAddHoPopup"
      :_trans-type="step1_info.trans_type"
      :_dong-info="dong_list[selectedDongIndex]"
      :_floor="selectedFloorIndex + 1"
      :_ho-info="ho_list.filter(it => {
              return it.dong_index == selectedDongIndex && it.floor == (selectedFloorIndex + 1);
            })[selectedHoIndex]"
      :exclusive-size-list="step1_info.room_list.filter(it => {
              return it.area == 'E'
            }).map(it => {
              return it.pyong
            }).sort((a, b) => a - b)"
      :real-size-list="step1_info.room_list.filter(it => {
              return it.area == 'R'
            }).map(it => {
              return it.pyong
            }).sort((a, b) => a - b)"
      @onCancel="() => {
        self.selectedDongIndex = -1;
        self.selectedHoIndex = -1;
        self.selectedFloorIndex = -1;
        self.showAddHoPopup = false;
      }"
      @onSave="(info) => onSaveHo(info)"
      :visible.sync="showAddHoPopup" />
  </div>
</template>

<script>
import MdHeaderBar2 from "../../../controls/MdHeaderBar2";
import Utils from "../../../../config/utils"
import HouseholdEditPopup from "../../../controls/popup/HouseholdEditPopup";
import Vue from "vue";
import MFSelect from "../../../controls/mf/MFSelect";

const $u = require('util');
export default {
  name: "RegNewOpenSite2",
  components: {HouseholdEditPopup, MdHeaderBar2, MFSelect},
  data() {
    let {step1Info, imageUrlList, remain_ho_count, dong_list, ho_list, floor_copy_list, selected_group} = this.init();
    return {
      u: Utils,
      ut: $u,
      self: this,
      step1_info: step1Info,
      image_url_list: imageUrlList,
      remain_ho_count: remain_ho_count,
      dong_list: dong_list,
      ho_list: ho_list,
      showAddHoPopup: false,
      showImagePicker: false,
      selectedDongIndex: -1,
      selectedFloorIndex: -1,
      selectedHoIndex: -1,
      floor_copy_list: floor_copy_list,
      activeIndex: 0,
      selected_group: selected_group
    };
  },
  mounted() {
    this.eventBus.$on('refresh_from_step1', () => {
      let {step1Info, imageUrlList, remain_ho_count, dong_list, ho_list, floor_copy_list, selected_group} = this.init();
      Utils.setState(this, {
        step1_info: step1Info,
        image_url_list: imageUrlList,
        remain_ho_count: remain_ho_count,
        dong_list: dong_list,
        ho_list: ho_list,
        showAddHoPopup: false,
        showImagePicker: false,
        selectedDongIndex: -1,
        selectedFloorIndex: -1,
        selectedHoIndex: -1,
        floor_copy_list: floor_copy_list,
        activeIndex: 0,
        selected_group: selected_group
      });
    })

     window.scrollTo(0,0);
  },
  methods: {
    init () {
      console.log("RegNew Site2 Init")
      console.log(this.$route.params.selected_group)
      let selected_group = this.$route.params.selected_group;
      let step1Info = this.$route.params.reg_info;
      let serverHoList = this.$route.params.ho_list;
      let serverDongList = this.$route.params.dong_list;
      let ho_list = [];
      let dong_list = [];
      let floor_copy_list = [];
      let remain_ho_count = step1Info.house_count;
      if (serverDongList != null) {
        dong_list = serverDongList.map((it, index) => {
          return {
            index: index,
            id: it.f_idx,
            dong: it.f_dong,
            floor: parseInt(it.f_floor),
            ho: parseInt(it.f_ho),
            editable: true
          };
        });

        let hoCount = 0;
        dong_list.forEach(dong => {
          hoCount += dong.ho;
        });
        remain_ho_count -= hoCount;
      }

      if (serverHoList != null) {
        ho_list = serverHoList.map(it => {
          let trans_type =
            it.f_trans_type
              .split(',')
              .filter(it => it != '');
          return {
            dong_index: dong_list.map(it_dong => {
              return it_dong.id
            }).indexOf(it.f_dong_idx),
            ho: it.f_ho,
            floor: it.f_floor,
            trans_type: trans_type.join(','),
            room: it.f_room,
            toilet: it.f_toilet,
            veranda: it.f_veranda,
            utility_room: it.f_utility_room,
            duplex: it.f_duplex,
            teras: it.f_teras,
            exclusive_size: it.f_exclusive_size,
            real_size: it.f_real_size,
            sale_price: trans_type.includes('0') ? it.f_sale_price : '',
            collateral_price: trans_type.includes('0') ? it.f_collateral_price : '',
            charter_price: trans_type.includes('1') ? it.f_charter_price : '',
            investment_price: trans_type.includes('2') ? it.f_investment_price : '',
            monthly_rent: trans_type.includes('3') && it.f_monthly_rent ? it.f_monthly_rent : '',
            monthly_rent_deposit: trans_type.includes('3') && it.f_monthly_rent_deposit ? it.f_monthly_rent_deposit : '',
            site_inquire_price: it.f_site_inquire_price,
            site_inquire_charter: it.f_site_inquire_charter,
            site_inquire_investment: it.f_site_inquire_investment,
            site_inquire_month: it.f_site_inquire_month,
            smb: it.f_smb,
            safe_charter: it.f_safe_charter,
            memo: it.f_memo,
            image_urls: it.f_image_urls,
            complete: it.f_complete ? it.f_complete : 'N'
          };
        });
      }

      if (serverDongList != null) {
        // if (step1Info.dong_count == serverDongList.length) {
        for (let i = 0; i < serverDongList.length; i++) {
          floor_copy_list.push({
            from: 1,
            to: 1,
            mode: 'A',
            editable: true
          });
        }
        // }
      }
      if (dong_list.length < step1Info.dong_count) {
        for (let i = dong_list.length; i < step1Info.dong_count; i++) {
          dong_list.push({
            index: i,
            id: -1,
            dong: '',
            floor: 1,
            ho: step1Info.dong_count == 1 ? step1Info.house_count : 1,
            editable: false
          });
          floor_copy_list.push({
            from: 1,
            to: 1,
            mode: 'A',
            editable: false
          });

          remain_ho_count -= step1Info.dong_count == 1 ? step1Info.house_count : 1;
        }
      }

      let imageUrlList = [];
      if (!Utils.isEmptyOrNull(step1Info.image_urls)) {
        imageUrlList = step1Info.image_urls.split(',').filter(it => {
          return !Utils.isEmptyOrNull(it)
        });
      }
      return {step1Info, imageUrlList, remain_ho_count, dong_list, ho_list, floor_copy_list, selected_group}
    },
    renderRoomNum(text) {
      let rlt;
      text = parseInt(text)
      if (text == 0)
        rlt = 1
      else if(text == 1)
        rlt = 1.5;
      else
        rlt = text;
      return rlt;
    },
    floorList (dongInfo) {
      let floorList = [];
      for (let i = dongInfo.floor - 1; i >= 0; i--) {
        floorList.push(i);
      }
      floorList.reverse();
      return floorList;
    },
    floorList2 (dongInfo) {
      let floorList = [];
      for (let i = dongInfo.floor; i > 0; i--) {
        floorList.push(i);
      }
      floorList.reverse();
      return floorList;
    },
    getNumList(max) {
      let list = [];
      for (let ind = 1; ind <= max; ind++) {
        list.push(ind);
      }
      return list;
    },
    renderText(text) {
      return text == '' || text == '0' ? '-' : text;
    },
    renderDupTerasText(isDup, isTeras) {
      let resultText = "-";
      if (isDup == 'Y' && isTeras == 'Y') {
        resultText = this.$t('site_detail.dup_teras');
      } else if (isDup == 'Y') {
        resultText = this.$t('room_info_popup.duplex_short');
      } else if (isTeras == 'Y') {
        resultText = this.$t('site_detail.teras_short');
      }

      return resultText;
    },
    replaceEnter (text) {
      return text.replace(/\n/g, " ");
    },
    getInputText (idx) {
      return $u.format(this.$t('register.input'), idx + 1)
    },
    onAddDong(dong_index) {
      let dong_list = this.dong_list;
      let dong_info = dong_list[dong_index];
      if (Utils.isEmptyOrNull(dong_info.dong)) {
        Utils.toast(this, this.$t('register.dong_name_placeholder'));
        return;
      }
      let ho_list = this.ho_list;
      let floor_copy_list = this.floor_copy_list;
      let isExist = ho_list.map(it => {
        return it.dong_index
      }).indexOf(dong_index) >= 0;
      if (isExist) {
        ho_list = ho_list.map(it => {
          if (it.dong_index == dong_index) {
            it.dong = dong_info.dong;
          }
          return it;
        });
        return;
      }

      dong_list[dong_index].editable = true;
      floor_copy_list[dong_index].editable = true;
      Utils.setState(this,{
        dong_list: dong_list,
        ho_list: ho_list,
        floor_copy_list: floor_copy_list
      });
    },
    checkHouseholdCount() {
      let maxHouse = this.step1_info.house_count;

    },
    onAddHo(dongIndex, floorIndex) {
      console.log('dongIndex: ', dongIndex, 'floorIndex: ', floorIndex);
      let dong_list = this.dong_list;
      let ho_list = this.ho_list;
      if (ho_list.filter(it => {
        return it.dong_index === dongIndex;
      }).length >= dong_list[dongIndex].ho) {
        Utils.toast(this, this.$t('register.dong_limited_ho_count'));
        return;
      }
      // this.selectedDongIndex = dongIndex;
      // this.selectedFloorIndex = floorIndex;
      // this.selectedHoIndex = -1;
      // this.showAddHoPopup = true;
      Utils.setState(this,{
        selectedDongIndex: dongIndex,
        selectedFloorIndex: floorIndex,
        selectedHoIndex: -1
      }, () => {
        this.showAddHoPopup = true;
      });
    },

    onUpdateHo(dongIndex, floorIndex, hoIndex) {
      Utils.setState(this,{
        selectedDongIndex: dongIndex,
        selectedFloorIndex: floorIndex,
        selectedHoIndex: hoIndex
      }, () => {
        this.showAddHoPopup = true;
      });
    },

    onSaveHo(hoInfo) {
      let ho_list = this.ho_list;
      if (this.selectedHoIndex > -1) {
        let update_ho = this.ho_list
          .filter(hoInfo => {
            return hoInfo.dong_index == this.selectedDongIndex && hoInfo.floor == (this.selectedFloorIndex + 1);
          })[this.selectedHoIndex];
        // ho_list = ho_list.map(it => {
        //   if (it.dong_index == self.state.selectedDongIndex && it.floor == self.state.selectedFloorIndex + 1 )
        // });
        // this.ho_list[this.ho_list.indexOf(update_ho)] = Object.assign({}, hoInfo, {
        //   complete: update_ho.complete
        // });
        Vue.set(this.ho_list, this.ho_list.indexOf(update_ho), Object.assign({}, hoInfo, {
          complete: update_ho.complete
        }));
      } else {
        hoInfo.dong_index = this.selectedDongIndex;
        hoInfo.floor = this.selectedFloorIndex + 1;
        hoInfo.complete = 'N';
        ho_list.push(hoInfo);
      }
      // Vue.set(this.ho_list, this.selectedHoIndex, hoInfo );
      Utils.setState(this,{
        ho_list: ho_list,
        showAddHoPopup: false,
        selectedDongIndex: -1,
        selectedFloorIndex: -1,
        selectedHoIndex: -1
      });
    },

    onCopyFloor(dongIndex) {
      let ho_list = this.ho_list;
      let floorCopyInfo = this.floor_copy_list[dongIndex];
      if (floorCopyInfo.from == floorCopyInfo.to) {
        return;
      }
      let copyHoList = ho_list.filter(it => {
        return it.dong_index == dongIndex && it.floor == floorCopyInfo.from
      });
      if (copyHoList.length < 1) {
        return;
      }

      let originHoList = ho_list.filter(it => {
        return it.dong_index == dongIndex && it.floor == floorCopyInfo.to
      });
      if (originHoList.length > 0 && originHoList.length != copyHoList.length) {
        Utils.toast(this, this.$t('register.copy_floor_ho_count_not_match'));
        return;
      }
      ho_list = ho_list.filter(it => {
        return it.dong_index != dongIndex || it.floor != floorCopyInfo.to
      });

      let newHoList = [];
      if (floorCopyInfo.mode == 'A') {
        newHoList = copyHoList.map(it => {
          return {
            dong_index: it.dong_index,
            ho: it.ho,
            floor: floorCopyInfo.to,
            trans_type: it.trans_type,
            room: it.room,
            toilet: it.toilet,
            veranda: it.veranda,
            utility_room: it.utility_room,
            duplex: it.duplex,
            teras: it.teras,
            exclusive_size: it.exclusive_size,
            real_size: it.real_size,
            sale_price: it.sale_price,
            collateral_price: it.collateral_price,
            charter_price: it.charter_price,
            investment_price: it.investment_price,
            monthly_rent: it.monthly_rent,
            monthly_rent_deposit: it.monthly_rent_deposit,
            site_inquire_price: it.site_inquire_price,
            site_inquire_charter: it.site_inquire_charter,
            site_inquire_investment: it.site_inquire_investment,
            site_inquire_month: it.site_inquire_month,
            smb: it.smb,
            safe_charter: it.safe_charter,
            complete: it.complete,
            memo: it.memo,
            image_urls: it.image_urls
          };
        });
      } else {
        if (originHoList.length == 0 && copyHoList.length > 0) {
          Utils.toast(this, this.$t('register.copy_floor_ho_count_not_match1'));
          return;
        }
        for (let i = 0; i < copyHoList.length; i++){
          originHoList[i].image_urls = copyHoList[i].image_urls;
        }
        newHoList = originHoList;
      }
      for (let i = 0; i < newHoList.length; i++) {
        if (floorCopyInfo.mode == 'A') {
          if (floorCopyInfo.from > 9) {
            newHoList[i].ho = floorCopyInfo.to + newHoList[i].ho.substring(2, 4);
          } else {
            newHoList[i].ho = floorCopyInfo.to + newHoList[i].ho.substring(1, 3);
          }
        }
        ho_list.push(newHoList[i]);
      }

      let dong_list = this.dong_list;
      if (ho_list.filter(it => {
        return it.dong_index == dongIndex;
      }).length > dong_list[dongIndex].ho) {
        Utils.toast(this, this.$t('register.dong_limited_ho_count'));
        return;
      }

      Utils.setState(this,{
        ho_list: ho_list
      });
    },

    onSaveSite() {
      let regInfo = this.step1_info;

      // if (this.image_url_list.length > 0) {
      //   regInfo.image_urls = this.image_url_list.join(',');
      // }
      regInfo.temporary_save = 'N';
      regInfo.drop_off = 'N';


      regInfo.house_info = JSON.stringify(this.ho_list.map(it => {
        return it;
      }));
      regInfo.dong_info = JSON.stringify(this.dong_list.filter(it => {
        return it.editable
      }));
      console.log("그룹정보 = ")
      console.log(this.selected_group)
      if (this.selected_group) {
        regInfo.group_idx = this.selected_group.f_idx;
      } else {
        regInfo.group_idx = '';
      }
      let self = this;
      Utils.requestPost(
        regInfo.site_idx > -1 ? this.$c.API.Site.updateSite_app : this.$c.API.Site.addSite_app,
        regInfo
      ).then(async result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          await this.$perf.setInt(this.$c.PREF_PARAMS.TEMP_STEP, 0);
          // Utils.toast(this, this.$t('common.save_success'));
          // this.eventBus.$emit('sale_modify',regInfo.site_idx);
          if (regInfo.site_idx > -1) {
            //매물 수정인 경우
            self.$router.back();
            self.$router.back();
            if (regInfo.changeAddress == 'Y') {
              self.$router.back();
            }
            //다중중복 이슈로 뒤로가기 한번더 해줌
            // self.$router.back();
          } else {
            //매물 새로 등록인 경우
            self.$router.back();
            self.$router.back();
            //다중중복 이슈로 뒤로가기 한번더 해줌
            // self.$router.back();
            if (regInfo.changeAddress == 'Y') {
              self.$router.back();
            }
          }

        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    getTransText (defaultText, hoInfo) {
      let transTypeList = hoInfo.trans_type.split(',').filter(it => {
        return it != '' && it != '3'
      });

      if (transTypeList.length == 2 && (hoInfo.trans_type.includes('0,2') || hoInfo.trans_type.includes('2,0'))) {
        return this.$t('interest.trading1');
      }


      return transTypeList.length > 1 ? this.$t('dongsi') : defaultText;
    },
    onCancel() {
      // let regInfo = this.step1_info;
      //
      // regInfo.house_info = JSON.stringify(this.ho_list);
      // regInfo.dong_info = JSON.stringify(this.dong_list.filter(it => {
      //   return it.editable
      // }));
      //
      // regInfo.temporary_save = 'N';
      // regInfo.drop_off = 'Y';
      // Utils.requestPost(
      //   regInfo.site_idx > -1 ? API.Site.updateSite : API.Site.addSite,
      //   regInfo
      // ).then(async result => {
      //   if (result.code === this.$c.API_RES_CODE.SUCCESS) {
      //     await this.$perf.setInt(this.$c.PREF_PARAMS.TEMP_STEP, 2);
      //     // this.props.navigation.pop(2);
      //     this.$router.back();
      //     this.$router.back();
      //   } else {
      //     Utils.toast(this, result.msg);
      //   }
      // });
      this.$router.back();
    }
  },
  inject: ["eventBus"],
  computed: {
    getRoomNum() {
      let roomNum = [];
      this.step1_info.room_num.split(',').filter(it => {
        return it != ''
      }).forEach(idx => {
        switch (Number(idx)) {
          case 0:
            roomNum.push(1);
            break;
          case 1:
            roomNum.push(1.5);
            break;
          case 2:
            roomNum.push(2);
            break;
          case 3:
            roomNum.push(3);
            break;
          case 4:
            [...Array(7).keys()].forEach(key => {
              roomNum.push(key + 4);
            })
            ;
            break;
        }
      });
      return roomNum.sort((a, b) => a - b);
    },
    forDongTable () {
      let result = [];
      this.dong_list.filter(it => it.editable).map((dongInfo, dong_idx) => {
        let floorList = [];
        for (let i = 0; i < dongInfo.floor; i++) {
          floorList.push(i);
        }
        let ho_list = this.ho_list.filter(it => {
          return it.dong_index == dong_idx
        });
        let saleShow = ho_list.some(it => {
          return it.trans_type.split(',').includes('0') && it.f_complete != 'Y'
        });
        // saleShow = saleShow && this.step1_info.trans_type.includes('0');

        let charterShow = ho_list.some(it => {
          return it.trans_type.split(',').includes('1') && it.f_complete != 'Y'
        });
        // charterShow = charterShow && this.step1_info.trans_type.includes('1');

        let investShow = ho_list.some(it => {
          return it.trans_type.split(',').includes('2') && it.f_complete != 'Y'
        });
        // investShow = investShow && this.step1_info.trans_type.includes('2');

        let monthlyShow = ho_list.some(it => {
          return it.trans_type.split(',').includes('3') && it.f_complete != 'Y'
        });
        // monthlyShow = monthlyShow && this.step1_info.trans_type.includes('3');
        result.push({
          dongInfo: dongInfo,
          floorList: floorList,
          ho_list: ho_list,
          saleShow: saleShow,
          investShow: investShow,
          charterShow: charterShow,
          monthlyShow: monthlyShow,
        });
      });
      return result;
    },
    getToiletNum() {
      let toiletNum = [];
      this.step1_info.toilet_num.split(',').filter(it => {
        return it != ''
      }).forEach(idx => {
        switch (Number(idx)) {
          case 1:
            toiletNum.push(1);
            break;
          case 2:
            toiletNum.push(2);
            break;
          case 3:
            [...Array(3).keys()].forEach(key => {
              toiletNum.push(key + 3);
            })
            ;
            break;
        }
      });
      return toiletNum.sort((a, b) => a - b);
    },
  },
}
</script>

<style scoped lang="scss">
  @import "../../../../assets/css/main/more/RegNewOpenSite2";
  .scroll-body {
    //overflow: auto;
    padding-top: $md_header_height;
    padding-bottom: 80px;
    width:480px;
    margin: auto;
  }
  .btn {
    padding: 0;
    width: 48px;
  }

  .trans_wrapper {
    background-color: #F2F2F2;
    height: 30px;
    width: 100%;
    color: white;
  }
  .trans_tag {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    font-family: $korean_gd_14_r;
  }
  .trans_trading_active {
    background-color: $trading;
  }
  .trans_charter_active {
    background-color: $charter;
  }
  .trans_month_active {
    background-color: $monthly;
  }
  .trans_invest_active {
    background-color: $invest;
  }
  .room_toilet_wrapper {
    background-color: #A7C9FB;
    height: 35px;
    width: 100%;
    justify-content: center;
    font-size: $fs_15;
    font-family: $korean_gd_15_r;
    color:black;
  }
  .dup_teras_wrapper {
    background-color: #F2F2F2;
    height: 30px;
    width: 100%;
    color: white;
  }
  .dup_teras_active {
    background-color: #93CDDD;
  }
  .cell_text {
    color: $black;
    font-size: $fs_14;
    font-family: $korean_gd_14_r;
  }
  .th {
    text-align: center;
    height: #{$TBL_ROW_HEIGHT}px;
    border-left:solid 0.5px $TBL_BORDER_COLOR;
    //border-color: $TBL_BORDER_COLOR;
    align-items: center;
    justify-content: center;
    padding: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contents/main/more/RegNewOpenSite2.vue